<template>
  <div class="footer">
    <div class="wrap">
        <p>Copyright copy;2001-2021 WENDU Corporation All Rights Reserved. 世纪文都教育科技集团股份有限公司 版权所有</p>
        <p>京网文[2014]2116-316号 | 京ICP证070272号 | 京ICP备05001816号-14 | 京公网安备 11010802020049号 | <br> 出版许可:京新出发京批字第直100085号 | 商务部特许经营(备):0110801311000117</p>
    </div>
  </div>
</template>

<script >
import { defineComponent,ref } from 'vue'
export default defineComponent({
 setup(){
     
     return{
        
     }
 }
})
</script>

<style lang="scss" scoped type="text/scss">
.footer{
    padding:40px 0 24px;
    background:#fff;
    font-size:14px;
    color:#869099;
    text-align: center;
    line-height: 20px;
    p{
        margin-bottom:16px;
    }
}
</style>
